export const amplify = {
  aws_project_region: 'eu-west-1',
  aws_cognito_identity_pool_id: import.meta.env.VITE_IDENTITY_POOL_ID,
  aws_cognito_region: 'eu-west-1',
  aws_user_pools_id: import.meta.env.VITE_USER_POOLS_ID,
  aws_user_pools_web_client_id: import.meta.env.VITE_USER_POOLS_WEB_CLIENT_ID,
}

export const submissionProcessorApi = import.meta.env.VITE_SUBMISSION_PROCESSOR_API as string ?? null
